import { useId } from "react";
export const UNLABELLED = "UNLABELLED";
export const usePrimitive = ({ children: propsChildren, label, as, ...rest }, defaultElement) => {
    const id = useId();
    const id2 = useId();
    const id3 = useId();
    const children = typeof propsChildren === "function"
        ? propsChildren(id, id2, id3)
        : propsChildren;
    const Element = as ?? defaultElement;
    return {
        Element,
        elementProps: {
            children,
            "aria-label": label === UNLABELLED ? undefined : label,
            "aria-labelledby": typeof propsChildren === "function"
                ? [id, id2, id3].join(" ")
                : undefined,
            ...rest,
        },
    };
};
//# sourceMappingURL=common.js.map